module.exports = __webpack_public_path__ + "img/home_detail.dcceed33.png";